import * as XLSX from 'xlsx';
import { Unit } from "../types/Unit";

export const readSerialNumberFile = (file: File, lastFile: boolean, setErrorMessage: (message: string) => void,
    units: Unit[], setUnits: (units: Unit[]) => void) => {
    var reader = new FileReader();
    var newUnits = units.slice(0);

    reader.onerror = () => {
        if (reader.error === null) return;
        setErrorMessage(reader.error.message);
    }

    reader.onloadend = () => {
        if (lastFile) {
            var fileUpload = document.getElementById("fileUpload");
            if (fileUpload !== null)
                (fileUpload as any).value = null;
            setUnits(newUnits);
        }
    }

    if (file.name.toLowerCase().endsWith("xlsx")) {
        parseExcelFile(reader, newUnits, file);
    } else if (file.name.toLowerCase().endsWith("xml")) {
        parseXmlFile(reader, newUnits, setErrorMessage, file);
    } else {
        parseTxtFile(reader, newUnits, file);
    }
}

export const parseSerialNumber = (hardwareId: string) => {
    hardwareId = hardwareId.trim();

    if (hardwareId.length === 8 && (hardwareId.startsWith("0") || hardwareId.startsWith("90")))
        return "";

    return hardwareId.toUpperCase();
}

export const parseModuleKey = (hardwareId: string) => {
    hardwareId = hardwareId.trim();

    if (hardwareId.length === 8 && (hardwareId.startsWith("0") || hardwareId.startsWith("90")))
        return hardwareId;

    return "";
}

const addUnit = (units: Unit[], unit: Unit) => {
    units.push(unit);
}

function parseTxtFile(reader: FileReader, units: Unit[], file: File) {
    reader.onload = () => {
        if (reader.result === null)
            return;
        var unitsToAdd = reader.result.toString();
        unitsToAdd.split("\n").forEach(u => {
            if (u !== "")
                addUnit(units, {
                    serialNumber: parseSerialNumber(u),
                    moduleKey: parseModuleKey(u)
                } as Unit);
        });
    };
    reader.readAsText(file);
}

function parseXmlFile(reader: FileReader, units: Unit[], setErrorMessage: (message: string) => void, file: File) {
    reader.onload = (event: any) => {
        if (reader.result === null)
            return;
        //var startIndex = getMaxId();
        var parseString = require('xml2js').parseString;
        parseString(reader.result, (err: any, result: any) => {
            try {
                result.licenseCredentials.devices[0].device.forEach((device: any) => {
                    addUnit(units, {
                        serialNumber: parseSerialNumber(device.serialNumber[0]),
                        moduleKey: parseModuleKey(device.serialNumber[0])
                    } as Unit);
                });
            }
            catch {
                setErrorMessage("Could not parse XML file. Only export files from WinPDM are allowed.");
            }
        });
    };
    reader.readAsText(file);
}

function parseExcelFile(reader: FileReader, units: Unit[], file: File) {
    reader.onload = (event: any) => {
        var workbook = XLSX.read(event.target.result, { type: 'binary' });
        var worksheet = workbook.Sheets[workbook.SheetNames[0]];
        var unitsToAdd = XLSX.utils.sheet_to_csv(worksheet).split("\n");
        unitsToAdd.forEach(u => {
            if (u !== "")
                addUnit(units, {
                    serialNumber: parseSerialNumber(u),
                    moduleKey: parseModuleKey(u)
                } as Unit);
        });
    };
    reader.readAsBinaryString(file);
}
